(() => {
  async function orderTop(section) {
    if (section.dataset.memysOrderStarted) return;
    section.dataset.memysOrderStarted = 'true';
    const items = [...section.querySelectorAll('[data-memys-product-id]')];
    const parent = items[0]?.parentElement;
    if (!parent || items.some(item => item.parentElement !== parent)) return;
    try {
      const url = new URL(section.dataset.orderUrl, location.origin);
      const previewId = new URLSearchParams(location.search).get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(7000) });
      if (!response.ok) throw new Error('Order unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const order = doc.querySelector('[data-memys-native-order="best-selling"]');
      if (!order) throw new Error('Native order missing');
      const ranks = new Map([...order.querySelectorAll('[data-product-id]')].map((item, index) => [item.dataset.productId, index]));
      if (items.some(item => !ranks.has(item.dataset.memysProductId))) throw new Error('Product missing from native order');
      const sorted = [...items].sort((a, b) => {
        const availability = Number(b.dataset.memysAvailable === 'true') - Number(a.dataset.memysAvailable === 'true');
        return availability || ranks.get(a.dataset.memysProductId) - ranks.get(b.dataset.memysProductId);
      });
      sorted.forEach(item => parent.append(item));
      section.dataset.memysOrder = 'native-best-selling';
    } catch {
      section.dataset.memysOrder = 'server-fallback';
    }
  }
  function init(root = document) {
    root.querySelectorAll('[data-memys-top]').forEach(orderTop);
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
